module.exports = __webpack_public_path__ + "transparenciasocial.jpg?e1513fdb3fa15928373940d79fc1ed7d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/transparenciasocial.jpg
// module id = 158
// module chunks = 0